.page-empty-state {
  .loader-icon {
    margin-top: 0 !important;
    margin-bottom: 24px !important;
  }
}

.no-data-sources-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
